/* global $ */

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "@/components/app/app.vue";
import store from "@/store";
import * as globalTypes from "@/store/mutation-types.js";
import router from "@/router";

/* Directives */
import "@/directives/general-directives.js";

/* Filters */
import "@/filters/date-filters.js";
import "@/filters/string-filters.js";

/* Defining Vue specific modules */
import Vuex from "vuex";
import axios from "axios";
import VueAxios from "vue-axios";
import VueTouch from "vue-touch";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import Datepicker from "vuejs-datepicker";
Vue.component(Datepicker);
import ConfigFileService from "@/services/config-file.service.js";
import globalCss from "./main.scss";
import customBootstrap from "./custom.css";
Vue.use(globalCss);

Vue.use(customBootstrap);
//  import 'main.scss'
import Vue2TouchEvents from "vue2-touch-events";

import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);

import { TreeGridPlugin } from '@syncfusion/ej2-vue-treegrid';
import '../node_modules/@syncfusion/ej2-base/styles/bootstrap4.css';
import '../node_modules/@syncfusion/ej2-buttons/styles/bootstrap4.css';
import '../node_modules/@syncfusion/ej2-calendars/styles/bootstrap4.css';
import '../node_modules/@syncfusion/ej2-dropdowns/styles/bootstrap4.css';
import '../node_modules/@syncfusion/ej2-inputs/styles/bootstrap4.css';
import '../node_modules/@syncfusion/ej2-navigations/styles/bootstrap4.css';
import '../node_modules/@syncfusion/ej2-popups/styles/bootstrap4.css';
import '../node_modules/@syncfusion/ej2-splitbuttons/styles/bootstrap4.css';
import "../node_modules/@syncfusion/ej2-grids/styles/bootstrap4.css";
import "../node_modules/@syncfusion/ej2-treegrid/styles/bootstrap4.css";

Vue.use(TreeGridPlugin);
import { SchedulePlugin } from '@syncfusion/ej2-vue-schedule/';
import "../node_modules/@syncfusion/ej2-vue-schedule/styles/bootstrap4.css";
import "../node_modules/@syncfusion/ej2-base/styles/bootstrap4.css";
import "../node_modules/@syncfusion/ej2-buttons/styles/bootstrap4.css";
import "../node_modules/@syncfusion/ej2-calendars/styles/bootstrap4.css";
import "../node_modules/@syncfusion/ej2-dropdowns/styles/bootstrap4.css";
import "../node_modules/@syncfusion/ej2-inputs/styles/bootstrap4.css";
import "../node_modules/@syncfusion/ej2-navigations/styles/bootstrap4.css";
import "../node_modules/@syncfusion/ej2-popups/styles/bootstrap4.css";
// import '../node_modules/@syncfusion/ej2-base/styles/material.css';
// import '../node_modules/@syncfusion/ej2-buttons/styles/material.css';
// import '../node_modules/@syncfusion/ej2-calendars/styles/material.css';
// import '../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
// import '../node_modules/@syncfusion/ej2-inputs/styles/material.css';
// import '../node_modules/@syncfusion/ej2-navigations/styles/material.css';
// import '../node_modules/@syncfusion/ej2-popups/styles/material.css';
// import '../node_modules/@syncfusion/ej2-vue-schedule/styles/material.css';
Vue.use(SchedulePlugin);
import "babel-polyfill";
import Es6Promise from "es6-promise";
Es6Promise.polyfill();
import moment from "moment";
moment.locale("be");


Vue.prototype.moment = moment;
Vue.use(Vue2TouchEvents /* , {
  disableClick: false,
  touchClass: "",
  tapTolerance: 10,
  swipeTolerance: 30,
  longTapTimeInterval: 400
} */);
Vue.use(moment);


/* Use Vue specific modules */
Vue.use(Vuex);
Vue.use(VueAxios, axios);
Vue.use(VueTouch);


const configFileHelper = new ConfigFileService();

Vue.config.productionTip = false;

export const mainBus = new Vue();

router.beforeEach((to, from, next) => {
  // store.commit(globalTypes.TOGGLE_MENU, false)
  next();
});

window.wisaVueApp = new Vue({
  el: "#app",
  store,
  router,
  components: {
    App
  },
  methods: {
    klasSelectie: function (value) {
      mainBus.$emit("extjs-klas-selectie", value);
    }
  },
  template: "<App/>"
  // render: h => h(App) // ofwel components: { App } /////////////////////////
});

window.mainVueApp = {
  initialize: function () {
    this.bindEvents();
    this.setupVue();
  },
  bindEvents: function () {
    document.addEventListener("deviceready", this.onDeviceReady, false);
    if (window.location.host.indexOf("localhost") !== -1) {
      // voor PC debugging
      configFileHelper.readFile();
    }
  },
  onDeviceReady: function () {
    window.open = cordova.InAppBrowser.open;
    // voor APP
    window.mainVueApp.receivedEvent("deviceready");

    // if (cordova.platformId === "android") {
    StatusBar.backgroundColorByHexString("#B90D3F");
    // }

    // Keyboard openen => focus in dit element leggen zodat dit terug in het nog resterende zichtbare deel van het scherm komt te staan
    $("body").on("focusin", "input, textarea", function (event) {
      window.latestElement = $(event.target);
    });
    $(window).resize(function () {
      setTimeout(function () {
        if (window.latestElement !== undefined) {
          window.latestElement[0].scrollIntoView();
        }
      }, 100);
    });

    cordova.getAppVersion.getVersionNumber(function (version) {
      console.log("versienummer: " + version);
      store.commit(globalTypes.SET_VERSIENUMMER, version);
    });

    cordova.getAppVersion.getAppName(function (appname) {
      console.log("projectNaam: " + appname);
      store.commit(globalTypes.SET_PROJECT_NAAM, appname);
      store.commit(globalTypes.SET_MENUBAR_ITEMS, {
        left: [],
        title: appname,
        right: []
      });
    });

    configFileHelper.readFile();

    // https://cordova.apache.org/docs/en/latest/reference/cordova-plugin-file/
    // Deze pc\ALE-L21\Interne opslag\Android\data\com.wisa.afwezighedenSecundairDebug\files
  },
  receivedEvent: function (id) {
    console.log("Received Event: " + id);
  },
  setupVue: function () {
    window.wisaVueApp;
  }
};

window.currentVueApp = window.mainVueApp.initialize();

window.parent.getVueWindowScope = function () {
  return window;
};
// Make sure service worker is suppoerted
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    //  .register('../static/sw_cached_pages.js') //development
    .register("./sw_cached_pages.js") // production
    .then(function (registration) {
      console.log("Service Worker registration successful with scope: ", registration.scope);
    })
    .catch(err => console.log(`services worker: error: ${err}`));
}
